import React from 'react';
import './FooterWC26.css';

function FooterWC26() {
  return (
    <footer className="footer-wc26">
      <div className="footer-wc26-content">
        <p>&copy; Praptrick</p>
        <p>
          {`© ${new Date().getFullYear()} World Cup 2026 Sweepstakes. All rights reserved.`}
        </p>
      </div>
    </footer>
  );
}

export default FooterWC26;
